import React, { useState, useRef } from 'react'
import { Popover, SelectChangeEvent, Box } from '@mui/material'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { User } from 'TypeDefs/Goal'
import { SelectContainer } from 'Components/Pages/Dashboard/NonprofitPlatformDashboard/TaskList/TaskItem.styled'
import { PopoverContent } from './TaskItem.styled'
import { TaskOwnerContent } from './TaskOwnerContent'
import { TaskOwnerSelector } from './TaskOwnerSelector'

type TaskAssignmentProps = {
  owner: User | null
  onAssignOwner: (owner: User | null) => Promise<void>
  disabled?: boolean
}

export const TaskAssignment = ({
  owner,
  onAssignOwner,
  disabled = false,
}: TaskAssignmentProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)
  const { teamMap } = useNonprofitOrgTeam()

  const handleAvatarClick = () => {
    if (!disabled) setIsPopoverOpen(true)
  }

  const handleClose = () => {
    setIsPopoverOpen(false)
  }

  const handleSelectOwner = async (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value
    if (selectedId === '') {
      await onAssignOwner(null)
    } else if (teamMap && selectedId in teamMap) {
      const selectedUser = teamMap[selectedId]
      await onAssignOwner({
        id: parseInt(selectedId, 10),
        firstName: selectedUser.firstName,
        lastName: selectedUser.lastName,
        email: selectedUser.email,
      } as User)
    }
    handleClose()
  }

  return (
    <Box ref={anchorRef}>
      <TaskOwnerContent
        owner={owner}
        onAvatarClick={handleAvatarClick}
        disabled={disabled}
      />
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PopoverContent>
          <SelectContainer>
            <TaskOwnerSelector
              owner={owner}
              onSelectOwner={handleSelectOwner}
            />
          </SelectContainer>
        </PopoverContent>
      </Popover>
    </Box>
  )
}
